import { AxiosRequestConfig } from "axios";
import { CohesiveAPIClient } from "../../client";
import { route } from "../../utils";
import { HarnessCapabilitiesResponse, HarnessCapability } from "./types";

// Export types
export * from "./types";

const ENDPOINTS = {
  HARNESS_CAPABILITIES: {
    LIST: "/api/v2/org/:organization_id/user/:user_id/harness-capabilities",
  },
};

export class HarnessCapabilitiesAPI {
  private client: CohesiveAPIClient;

  constructor(client: CohesiveAPIClient) {
    this.client = client;
  }

  /**
   * List the runtimes this user may start a chat on, with the models each accepts. Cohesive is
   * always the first entry and always available; the agent harnesses appear only where the
   * harness runtime is enabled for the user.
   */
  async list(config?: AxiosRequestConfig): Promise<HarnessCapability[]> {
    const orgId = await this.client.getOrgID();
    const userId = await this.client.getUserID();

    const response = await this.client.axios.get<HarnessCapabilitiesResponse>(
      route(ENDPOINTS.HARNESS_CAPABILITIES.LIST, {
        organization_id: orgId || "",
        user_id: userId || "",
      }),
      config,
    );

    return response.data.data.harness_capabilities;
  }
}
